import { useState } from "react";
import {
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  HStack,
  useDisclosure,
  Input,
  Flex,
  Text,
} from "@chakra-ui/react";
import { useAppContext } from "../../../../contexts/AppContext";
import NavUploadDrawer from "./NavUploadDrawer";
import AddNavModal from "./AddNavModal";
import { Check, Loader, UploadCloud } from "lucide-react";
import TableFilters from "../../../general/TableFilters";

const NavTable = ({ fund, onOpenNavDrawer }) => {
  const { formatDate, tableSize } = useAppContext();
  const [selectedNav, setSelectedNav] = useState(null);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchTerm, setSearchTerm] = useState("");
  const [localNavs, setLocalNavs] = useState(fund?.navs || []);

  const addNavToList = (newNav) => {
    setLocalNavs((prev) => [
      {
        ...newNav,
        fundName: fund.fundName,
        uploadedBy: "Jeremy Tritz",
      },
      ...prev,
    ]);
  };

  const openDrawer = (nav) => {
    setSelectedNav(nav);
    setDrawerOpen(true);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "validated":
        return "green";
      case "to review":
        return "blue";
      default:
        return "gray";
    }
  };

  const [filters, setFilters] = useState({});
    const labelMap = {
      status: "Status",
    };
    const filterOptions = {
      status: [
        "to review",
        "validated",
      ],
    };

    const filteredNavs = localNavs
    .filter((nav) => {
      const matchesUploader = nav.uploadedBy?.toLowerCase().includes(searchTerm.toLowerCase());
  
      const matchesStatus =
        !filters.status || filters.status.length === 0 || filters.status.includes(nav.status);
  
      return matchesUploader && matchesStatus;
    })
    .sort((a, b) => new Date(b.uploadDate) - new Date(a.uploadDate));
  

  return (
    <>
      <Flex direction={"column"} gap={8}>
        <AddNavModal
          onClose={onClose}
          isOpen={isOpen}
          onUpload={(navData) => {
            // Crée une nouvelle instance propre du nav avec isNewUpload
            const cleanNav = JSON.parse(JSON.stringify(navData));
            setSelectedNav({
              ...cleanNav,
              fundName: fund.fundName,
              uploadedBy: "Jeremy Tritz",
            });
            setDrawerOpen(true);
          }}
        />

        <Flex gap={2} flex={1} justifyContent={"space-between"}>
          <HStack>
          <Input
  placeholder="Search by uploader..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  flex={1}
  w={"260px"}
/>

          <TableFilters
            filters={filters}
            setFilters={setFilters}
            filterOptions={filterOptions}
            labelMap={labelMap}
          />
          </HStack>
          <Button onClick={onOpen} leftIcon={<UploadCloud size={16} />}>
            Upload NAV
          </Button>
        </Flex>


          <TableContainer>
            <Table variant="simple" size={tableSize}>
              <Thead>
                <Tr>
                  <Th>Upload date</Th>
                  <Th>Valuation date</Th>
                  <Th>Status</Th>
                  <Th>Uploaded by</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
              {filteredNavs.length > 0 ? (
                filteredNavs.map((nav, index) => (
                  <Tr key={index}>
                    <Td fontWeight="500">
                      <Badge colorScheme="transparent">{nav.uploadDate ? formatDate(nav.uploadDate) : "N/A"}</Badge>
                    </Td>
                    <Td>
                      <Badge colorScheme="transparent">{nav.valuationDate
                        ? formatDate(nav.valuationDate)
                        : "N/A"}</Badge>
                    </Td>
                    <Td>
                      <Badge colorScheme={getStatusColor(nav.status)} >
                        <Flex gap={1}>{nav.status === "validated" ? <Check size={14} /> : <Loader size={14} />}{nav.status}</Flex>
                      </Badge>
                    </Td>
                    <Td>{nav.uploadedBy}</Td>
                    <Td>
                      <HStack spacing={1}>
                        <Button
                          size="xs"
                          variant="outline"
                          onClick={() => openDrawer(nav)}>
                          {nav.status === "to review" ? "Review" : "View"}
                        </Button>
                      </HStack>
                    </Td>
                  </Tr>
                ))
                            ) : (
                              <Tr>
                                <Td colSpan="6">
                                  <Text textAlign="center" py={10} color="gray.500">
                                  No NAVs match your filters.
                                  </Text>
                                </Td>
                              </Tr>
                            )}

              </Tbody>
            </Table>
          </TableContainer>
      </Flex>

      <NavUploadDrawer
        isOpen={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        nav={selectedNav}
        onValidated={addNavToList}
      />
    </>
  );
};

export default NavTable;
